import { z } from "zod";

// Словарь — CHECK в БД бэкенда (docs/tz/03-backend.md, таблица products).
export const productTypeSchema = z.enum(["subscription", "non_consumable"]);
export type ProductType = z.infer<typeof productTypeSchema>;

export const productSourceSchema = z.enum(["rc_snapshot", "manual"]);

export const productSchema = z.object({
  product_id: z.string(),
  display_name: z.string(),
  type: productTypeSchema,
  period: z.string().nullable(),
  trial: z.string().nullable(),
  subscription_group: z.string().nullable(),
  active: z.boolean(),
  sort_order: z.number().int(),
  source: productSourceSchema,
  updated_at: z.string(),
});
export type Product = z.infer<typeof productSchema>;

export const productsResponseSchema = z.object({ items: z.array(productSchema) });
export type ProductsResponse = z.infer<typeof productsResponseSchema>;

// 202 {job_id: N, status: null} при настроенном RevenueCat, иначе 200 {job_id: null,
// status: "not_configured"}. `exclude_none` у модели ответа не включён, поэтому ОБА поля приходят
// всегда, и `status` в рабочей ветке равен null: без `.nullable()` `.parse` ронял всю страницу
// ровно тогда, когда обновление реально запускалось (iteration-check волн 1–3, P2-12).
export const productsRefreshResponseSchema = z.object({
  job_id: z.number().int().nullable().optional(),
  status: z.literal("not_configured").nullable().optional(),
});
export type ProductsRefreshResponse = z.infer<typeof productsRefreshResponseSchema>;
